import React, { useState } from "react";
import { BsList, BsX } from "react-icons/bs";

function TableOfContents({ headings, activeId }) {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = (e, id) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      const navbarHeight = 100; // Account for fixed navbar
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - navbarHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });

      // Close mobile menu after navigation
      setIsOpen(false);
    }
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  if (!headings || headings.length === 0) {
    return null;
  }

  return (
    <>
      {/* Mobile Toggle Button */}
      <button 
        className="toc-toggle-btn"
        onClick={toggleMenu}
        aria-label="Toggle Table of Contents"
        aria-expanded={isOpen}
      >
        {isOpen ? <BsX size={24} /> : <BsList size={24} />}
      </button>

      {/* Mobile Backdrop */}
      {isOpen && (
        <div 
          className="toc-backdrop"
          onClick={() => setIsOpen(false)}
          aria-hidden="true"
        />
      )}

      {/* TOC Sidebar */}
      <nav 
        className={`toc-sidebar ${isOpen ? 'open' : ''}`}
        aria-label="Table of Contents"
      >
        <div className="toc-content">
          <h2 className="toc-heading">On this page</h2>
          <ul className="toc-list">
            {headings.map((heading) => (
              <li 
                key={heading.id} 
                className={`toc-item toc-item-h${heading.level}`}
              >
                <a
                  href={`#${heading.id}`}
                  className={`toc-link ${activeId === heading.id ? 'active' : ''}`}
                  onClick={(e) => handleClick(e, heading.id)}
                  aria-current={activeId === heading.id ? 'true' : undefined}
                >
                  {heading.text}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </nav>
    </>
  );
}

export default TableOfContents;